import type { ProfileCommon } from "./profileCommon";

export type AdminUserType = "ADMIN" | "CSM" | "CSE";

export type AdminProfile = ProfileCommon & {
  /** SSO identity provider identifier */
  idp?: string;
  idp_logout_url?: string;
  /** Distinguishes admin sub-roles, e.g. "CSE", "CSM", "ADMIN" */
  user_type: AdminUserType | string;
};

/** Narrows a profile value to AdminProfile at runtime */
export function isAdminProfile(profile: unknown): profile is AdminProfile {
  return typeof profile === "object" && profile !== null && "user_type" in profile;
}
